var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ttr"},_vm._l((5),function(i){return _c('div',{staticClass:"ttr__ball",class:{
      'ttr__ball--active': i - 1 === _vm.getGamesRejectedStreak,
      'ttr__ball--danger': i === 5,
    }},[_c('span',{staticClass:"ttr__ball-label"},[_vm._v(_vm._s(i))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }